import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Central deep link handling service for join codes.
 * - Emits join codes when a deep link like `caldevo://join?code=...` is opened
 * - Buffers the last code so a page can consume it on init (cold start case)
 */
@Injectable({ providedIn: 'root' })
export class DeepLinkService {
  private readonly joinCodeSubject = new Subject<string>();
  readonly joinCodes$ = this.joinCodeSubject.asObservable();

  private lastJoinCode: string | null = null;

  emitJoinCode(code: string) {
    this.lastJoinCode = code;
    this.joinCodeSubject.next(code);
  }

  /**
   * Returns and clears the last buffered code. Use this on page init to handle cold starts.
   */
  consumeLastJoinCode(): string | null {
    const code = this.lastJoinCode;
    this.lastJoinCode = null;
    return code;
  }
}
